// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Loginpage from "./components/Loginpage";
// import Homepage from "./components/Homepage";

// function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route path="/" element={<Loginpage />} />
//         <Route path="/login" element={<Loginpage />} />
//         <Route path="/home" element={<Homepage />} />
//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;


import { BrowserRouter, Routes, Route } from "react-router-dom";
import Loginpage from "./components/Loginpage";
import Homepage from "./components/Homepage";
import VideoPage from "./components/VideoPage";  // नया component import करो
import CategoryVideos from "./components/CategoryVideos";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Login routes */}
        {/* <Route path="/" element={<Loginpage />} />
        <Route path="/login" element={<Loginpage />} /> */}

        {/* Homepage */}
        <Route path="/" element={<Homepage />} />

        {/* VideoPage route */}
        <Route path="/video/:id" element={<VideoPage />} />
        <Route path="/category/:id" element={<CategoryVideos />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
